export const Translate = {
  /** 管理者 */
  Manager: 1,
  /** 普通 */
  Normal: 2,
  /** 个人 */
  Person: 3,
}
